module.exports = __webpack_public_path__ + "static/media/selected_view_icon.8f387b04.svg";